import dateUtils from "../utils/DateUtils";
import textUtils from "../utils/TextUtils";
import subscriptionUtils from "../utils/SubscriptionUtils";
import {useEffect, useState} from "react";
import users_api from "../api/users";
import GenericInput from "../components/GenericInput";


const AccessCodesTable = (props) => {

    const subtitle = props.subtitle
    const _type = props.type
    const showDelete = props.showDelete
    const showName = props.showName
    const showEmail = props.showEmail

    // Error
    const setDialogTitle = props.setDialogTitle
    const setDialogText = props.setDialogText

    const [itemsPerPage, setItemsPerPage] = useState(50);
    // Table Content

    const [page, setPage] = useState(0)
    const [pageData, setPageData] = useState([])
    const [totalPages, setTotalPages] = useState(1)

    const [codeSearch, setCodeSearch] = useState("");
    const [codeSearchQuery, setCodeSearchQuery] = useState("");


    useEffect(() => {
        GetAccessCodes()
    }, [page, codeSearchQuery, itemsPerPage]);

    const GetAccessCodes = () => {
        if (!page && page !== 0) return
        let response = users_api.GetAccessCodes(itemsPerPage, page * itemsPerPage,
            _type==="usable", _type==="expired", _type==="used", codeSearchQuery)
        response.then(
            response => {
                // Page items
                let data = response.data.tokens
                setPageData(data)

                // Calculate total pages:
                let pages_needed = Math.ceil(response.data.total_count / itemsPerPage)
                if (pages_needed < 1) pages_needed = 1

                setTotalPages(pages_needed)
            }
        ).catch((err) => {
            setDialogTitle("Fetching Error")
            setDialogText("There was an error fetching the access codes. Please try again")
        })
    }

    const DeleteAccessCode = (_access_code_id) => {
        let response = users_api.DeleteAccessCode(_access_code_id)
        response.then(
            response => {
                GetAccessCodes()
            }
        ).catch((err) => {
            setDialogTitle("Deletion Error")
            setDialogText("There was an error deleting the access code. Please try again")
        })
    }

    const handleNumberClick = (ev) => {
        if (!page && page !== 0) return;
        if (!ev.target.id && ev.target.id !== 0) return;
        let pg = parseInt(ev.target.id)
        setPage(pg);
    }

    const handleNextPageClick = () => {
        if (!page && page !== 0) return;
        if (page + 1 < totalPages) setPage(page + 1)
    }

    const handlePreviousPageClick = () => {
        if (!page && page !== 0) return;
        if (page > 0) setPage(page - 1)
    }

    return (
        <>
            <div className="page-subtitle">
                {subtitle}
            </div>
            <div className="items-per-page-container">
                <label>Items per page: </label>
                <select
                    value={itemsPerPage}
                    onChange={(e) => {
                        setItemsPerPage(parseInt(e.target.value));
                        setPage(0);
                    }}
                >
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={200}>200</option>
                </select>
            </div>
            <div className="search-users-container">
                <div className="user-search-field-container">
                    <GenericInput label="Search access code"
                                  value={codeSearch}
                                  updateValue={setCodeSearch} />

                    <div className="search-actions-row">
                        <div className="search-button link" onClick={() => setCodeSearchQuery(codeSearch)}>
                            Search
                        </div>
                        <div className="reset-button link" onClick={() => {
                            setCodeSearch("");
                            setCodeSearchQuery("");
                        }}>
                            Reset
                        </div>
                    </div>
                </div>
            </div>
            <div className="table-container">
                <div className="table-row">
                    <div className="table-column heading">Access Code</div>
                    <div className="table-column heading">Expires</div>
                    <div className="table-column heading">Subscription</div>
                    <div className="table-column heading">Subscription Length (days)</div>
                    <div className="table-column heading">Subscription Discount</div>
                    <div className="table-column heading">Subscription Discount Type</div>
                    <div className="table-column heading">Force Stripe</div>
                    {showName && <div className="table-column heading">Name</div>}
                    {showEmail && <div className="table-column heading">Email</div>}
                    <div className={showDelete && showDelete ? "table-column heading" : "table-column heading last"}>Status</div>
                    {showDelete && showDelete ? <div className="table-column heading last">Modify</div> : null}
                </div>
                {pageData && pageData.map((item, idx) => {
                    return (
                        <div className="access-codes-table-wrapper">
                            <div className="table-row">
                                <div className="table-column">{item.token}</div>
                                <div className="table-column">{dateUtils.short_display_date(item.expiry_date)}</div>
                                <div
                                    className="table-column">{textUtils.titleCase(subscriptionUtils.SubscriptionTypeToString(item.membership_tier))}</div>
                                <div
                                    className="table-column">{subscriptionUtils.SubscriptionLengthToDays(item.membership_length)}</div>
                                <div className="table-column">{item.discount_percentage ? item.discount_percentage : 0}%</div>
                                <div className="table-column">
                                    {item.discount_percentage && item.discount_percentage
                                        ? (item.discount_membership_type && item.discount_membership_type ?
                                            textUtils.titleCase(subscriptionUtils.SubscriptionTypeToString(item.discount_membership_type))
                                            : "All Memberships")
                                        : "N/A"}
                                </div>
                                <div className="table-column">{item.force_stripe_flow ? "Yes" : "No"}</div>
                                {showName && (
                                    <div className="table-column">
                                        {item.used_by_firstname && item.used_by_lastname
                                            ? `${item.used_by_firstname} ${item.used_by_lastname}`
                                            : "—"}
                                    </div>
                                )}
                                {showEmail && (
                                    <div className="table-column wrap">
                                        {item.used_by_email || "—"}
                                    </div>
                                )}
                                <div className={showDelete && showDelete ? "table-column" : "table-column last"}>{item.status}</div>
                                {showDelete && showDelete ?
                                    <div className="table-column last">
                                        <div className="table button link" onClick={() => DeleteAccessCode(item.id)}>
                                            Delete
                                        </div>
                                    </div>
                                    : null}
                            </div>
                        </div>
                    )
                })}
            </div>
            <div className="table-navigation-button-container">
                <div className="table-left button link" onClick={() => handlePreviousPageClick()}>{"<"}</div>
                <div className="table-pages">
                    {Array(totalPages).fill("item").map((_, idx) => {
                        return (
                            <>
                                <div className={page === idx ? "page active link" : (
                                        idx >= page + 3 ? "page-hidden" : (idx <= page - 3 ? "page-hidden" : "page link"))}
                                     onClick={handleNumberClick}
                                     id={idx.toString()}>
                                    {idx + 1}
                                </div>
                            </>
                        )
                    })}
                </div>
                <div className="table-right button link" onClick={() => handleNextPageClick()}>{">"}</div>
            </div>
        </>
    )

}

export default AccessCodesTable